import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { LostReport } from "../types";

type GetLossReportsToMatchParams = {
	reportId: number;
};

const fetchLossReportsToMatch = async (reportId: number): Promise<LostReport[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getLossReportsToMatchByReportId",
		bind: {
			reportId,
		},
	});

	return response.data.result;
};

export const useGetLossReportsToMatchByReportId = ({ reportId }: GetLossReportsToMatchParams) => {
	return useQuery<LostReport[]>({
		queryKey: ["getLossReportsToMatch", reportId],
		queryFn: () => fetchLossReportsToMatch(reportId),
		refetchOnWindowFocus: true,
		refetchOnMount: true,
		staleTime: 0,
		select: (data): LostReport[] => {
			return data;
		},
	});
};
